import React from 'react'
import { useTranslation } from 'react-i18next'
import Tooltip from 'rc-tooltip'
import ConsignmentItemInlineEditCell from './ConsignmentItemInlineEditCell'

interface ConsignmentItemPackagesCellProps {
  totalNumberOfPackages: number
  packagingCount: number
  isEditing: boolean
  draft: string
  isSaving: boolean
  editDisabled: boolean
  onStartEditing: () => void
  onDraftChange: (value: string) => void
  onSave: () => void
  onCancel: () => void
}

function ConsignmentItemPackagesCell({
  totalNumberOfPackages,
  packagingCount,
  isEditing,
  draft,
  isSaving,
  editDisabled,
  onStartEditing,
  onDraftChange,
  onSave,
  onCancel,
}: ConsignmentItemPackagesCellProps) {
  const { t } = useTranslation()

  if (packagingCount === 1) {
    return (
      <ConsignmentItemInlineEditCell
        isEditing={isEditing}
        draft={draft}
        isSaving={isSaving}
        editDisabled={editDisabled}
        label={t('declaration.p5.quantity')}
        type="number"
        onStartEditing={onStartEditing}
        onDraftChange={onDraftChange}
        onSave={onSave}
        onCancel={onCancel}
      >
        {totalNumberOfPackages}
      </ConsignmentItemInlineEditCell>
    )
  }

  if (packagingCount > 1) {
    return (
      <span className="d-inline-flex align-items-center gap-1">
        {totalNumberOfPackages}
        <Tooltip
          overlayClassName="tooltip-lg"
          placement="top"
          overlay={<small>{t('declaration.p5.multiPackagingNotEditable')}</small>}
        >
          <button
            type="button"
            className="btn btn-link btn-gray-700 p-0 h-100"
            aria-label={t('declaration.p5.multiPackagingNotEditable')}
          >
            <i className="fal fa-exclamation-circle text-warning" />
          </button>
        </Tooltip>
      </span>
    )
  }

  return <span>{totalNumberOfPackages}</span>
}

export default ConsignmentItemPackagesCell
